import {
  Analytics,
  Close,
  ContentPasteSearch,
  Feedback,
  HomeRounded,
  InsertChart,
  ManageSearch,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MENU_LIST } from "utility/constants";

const SideMenu = ({handleDrawerToggle} : any) => {
  const navigate = useNavigate();
  const [showFeedback, setShowFeedback] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);

  const iconMapper = (icon: string) => {
    switch (icon) {
      case "home":
        return <HomeRounded />;
      case "pct":
        return <ContentPasteSearch />;
      case "canexp":
        return <ManageSearch />;
      case "metrix":
        return <InsertChart />;
      case "cdad":
        return <Analytics />;
      default:
        return null;
    }
  };

  return (
    <>
      <List sx={{ height: "100%" }}>
        <ListItem key={"logo"}>
        <div style={{ padding: "8px" }}><img src="https://www.ascentt.com/wp-content/uploads/thegem-logos/logo_3ecf80c1978fe47f22d64bd6da182d45_1x.png" alt="Ascentt INC"/></div>
        </ListItem>
        {MENU_LIST.map((menu) => {
          if (menu.label === "Correlation Metrix") {
            if (
              window.location.origin === "https://localhost:3000"
            ) {
              return (
                <ListItem key={menu.label} disablePadding>
                  <ListItemButton
                    alignItems="center"
                    onClick={() => {navigate(menu.route); handleDrawerToggle()}}
                  >
                    <ListItemIcon
                      sx={{ minWidth: "unset", marginRight: "8px" }}
                    >
                      {iconMapper(menu.icon)}
                    </ListItemIcon>
                    <ListItemText primary={menu.label} />
                  </ListItemButton>
                </ListItem>
              );
            }
            return null;
          } else {
            return (
              <ListItem key={menu.label} disablePadding>
                <ListItemButton
                  alignItems="center"
                  onClick={() => {navigate(menu.route); handleDrawerToggle()}}
                >
                  <ListItemIcon sx={{ minWidth: "unset", marginRight: "8px" }}>
                    {iconMapper(menu.icon)}
                  </ListItemIcon>
                  <ListItemText primary={menu.label} />
                </ListItemButton>
              </ListItem>
            );
          }
        })}
      </List>
      <Box display={"flex"} p={1}>
        <Tooltip title={"Add your feedback!"}>
          <Button
            variant="text"
            fullWidth
            onClick={() => {setShowFeedback(true); handleDrawerToggle()}}
            startIcon={<Feedback color={"warning"} />}
          >
            <Typography variant="button">Feedback</Typography>
          </Button>
        </Tooltip>
        <Tooltip title={"Report an error!"}>
          <Button
            variant="text"
            fullWidth
            onClick={() => {setShowError(true); handleDrawerToggle()}}
            startIcon={<Feedback color={"error"} />}
          >
            <Typography variant="button">Error</Typography>
          </Button>
        </Tooltip>
      </Box>
      <Dialog
        open={showFeedback}
        onClose={() => {setShowFeedback(false); handleDrawerToggle()}}
        fullWidth
        fullScreen
        sx={{ margin: 3 }}
      >
        <DialogContent sx={{ margin: 0, padding: 0, overflowY: "hidden" }}>
          <IconButton
            aria-label="close"
            onClick={() => {setShowFeedback(false); handleDrawerToggle()}}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              backgroundColor: (theme) => theme.palette.background.default,
            }}
          >
            <Close />
          </IconButton>
          <iframe
            id="feedback-form"
            title="feedback-form"
            width="100%"
            height="100%"
            src="https://forms.office.com/Pages/ResponsePage.aspx?id=HS1kjAnXsEerEAgK8QeY-_ZiDQwljdNAhcSRxW2aRG1UNkZDQUdRUThTTlZPTjhXWk1PWUE2SFFRRi4u&embed=true"
            style={{ border: "none", maxWidth: "100%", maxHeight: "100vh" }}
          >
            {" "}
          </iframe>
        </DialogContent>
      </Dialog>
      <Dialog
        open={showError}
        onClose={() => {setShowError(false); handleDrawerToggle()}}
        fullWidth
        fullScreen
        sx={{ margin: 3 }}
      >
        <DialogContent sx={{ margin: 0, padding: 0, overflowY: "hidden" }}>
          <IconButton
            aria-label="close"
            onClick={() => {setShowError(false); handleDrawerToggle()}}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              backgroundColor: (theme) => theme.palette.background.default,
            }}
          >
            <Close />
          </IconButton>
          <iframe
            id="error-form"
            title="error-form"
            width="100%"
            height="100%"
            src="https://forms.office.com/Pages/ResponsePage.aspx?id=HS1kjAnXsEerEAgK8QeY-6ANV4hnd6JDr5fn8-EW7a1UNzE1MkFVTDRRMEhQNEs1UVFQN1g0NzY1Ti4u&embed=true"
            style={{ border: "none", maxWidth: "100%", maxHeight: "100vh" }}
          >
            {" "}
          </iframe>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SideMenu;
